import { RegionEnum } from '~/api/types';
import { useGetUserQuery } from '~/api/v2/hooks';

const useRegion = (): RegionEnum => {
  const { data: user } = useGetUserQuery({});

  return user?.region ?? RegionEnum.US;
};

export default useRegion;
